import { render, staticRenderFns } from "./Savingplan.vue?vue&type=template&id=6a082cb4&scoped=true&"
import script from "./Savingplan.vue?vue&type=script&lang=js&"
export * from "./Savingplan.vue?vue&type=script&lang=js&"
import style0 from "./Savingplan.vue?vue&type=style&index=0&id=6a082cb4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a082cb4",
  null
  
)

export default component.exports